module.exports = require("react");


//////////////////
// WEBPACK FOOTER
// external "react"
// module id = 6
// module chunks = 0